export default [
    {
      // 图标解释标题
      title: $t('integration.magnetism_type_icon'),
      // 图标类型
      type: 'magnetismType'
    },
    {
      title: $t('integration.configuration_status_icon'),
      type: 'configStatus'
    },
    {
      title: $t('integration.magnetism_status_icon'),
      type: 'equiStatus'
    },
    {
      title: $t('integration.mount_type_icon'),
      type: 'carrierType'
    }
  ]
  